import Logger from 'js-logger';
import {ILogger} from 'js-logger/src/types';
import _Vue from 'vue';

declare module 'vue/types/vue' {

// tslint:disable-next-line: interface-name
  interface Vue {
    $log: ILogger;
  }
}
const logLevel = process.env.NODE_ENV === 'production' ? 'INFO' : 'DEBUG';
Logger.useDefaults({
  defaultLevel: Logger[logLevel],
  formatter: (messages, context) => {
    let level = '';
    if (context.hasOwnProperty('level')) {
      level = '[' + context.level.name.padStart(5, ' ') + ']';
    }
    let name: string = '';

    if (context.name) {
      name = context.name.padEnd(10, ' ').slice(0, 10) + ' : ';
    }
    // дату можно включить в настройках браузера
    // let date = new Date();
    // let hours = date.getHours().toString().padStart(2, "0");
    // let minutes = date.getMinutes().toString().padStart(2, "0");
    // let seconds = date.getSeconds().toString().padStart(2, "0");
    // let month = (date.getMonth() + 1).toString().padStart(2, "0");
    // let day = date.getDate().toString().padStart(2, "0");
    // let milliseconds = date.getMilliseconds().toString().padStart(3, "0");
    // let dateStr = hours + ":" + minutes + ":" + seconds + "." + milliseconds + " " + day + "." + month + "." + date.getFullYear();
    messages.unshift(level, name)
  },
});
const consoleHandler = Logger.createDefaultHandler();

Logger.setHandler((messages, context) => {
  consoleHandler(messages, context);
});

export function LoggerPlugin(Vue: typeof _Vue): void {
  Vue.prototype.$log = Logger;
}
